const valueSuffix = 'v';
const expirySuffix = 'e';

const getItemValue = async (key) => {
  try {
    const raw = sessionStorage.getItem(`${key}:${valueSuffix}`);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    console.error(`Failed to fetch storage item value with key ${key}`, err);
    return null;
  }
};

const getItemExpiry = async (key) => {
  try {
    const raw = sessionStorage.getItem(`${key}:${expirySuffix}`);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    console.error(`Failed to fetch storage item expiry with key ${key}`, err);
    return null;
  }
};

const getItem = async (key) => {
  try {
    const value = await getItemValue(key);
    const expiry = await getItemExpiry(key);
    if (!isNaN(expiry) && (+expiry >= new Date().getTime() || +expiry <= 0)) {
      return value;
    }
  } catch (err) {
    console.error(`Failed to fetch storage item with key ${key}`, err);
  }
  return null;
};

const setItem = async (key, value, ttlMs = 0) => {
  const exp = value?.expiry || (ttlMs > 0 ? Date.now() + ttlMs : 0);
  try {
    sessionStorage.setItem(`${key}:${valueSuffix}`, JSON.stringify(value));
    sessionStorage.setItem(`${key}:${expirySuffix}`, JSON.stringify(exp));
    return true;
  } catch (err) {
    console.error(`Failed to store storage item with key ${key}`, err);
    return false;
  }
};

const PRESERVED_KEYS = ['cid'];

const clear = async () => {
  const preserved = PRESERVED_KEYS.reduce((acc, key) => {
    const value = sessionStorage.getItem(key);
    if (value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});
  sessionStorage.clear();
  Object.entries(preserved).forEach(([key, value]) => sessionStorage.setItem(key, value));
};

const storage = {
  getItemValue,
  getItemExpiry,
  getItem,
  setItem,
  clear
};

export default storage;
